import { createApp } from 'vue'
import App from './App.vue'
//导入当前项目的路由器对象
import router from './router'
//导入当前项目的全局状态管理对象
import store from './store'

//导入element-plus
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
//导入element-plus的样式
import 'element-plus/dist/index.css'
//导入echarts
import * as echarts from 'echarts'

//app.config.globalProperties.$echarts = echarts 

createApp(App).use(store).use(router).use(ElementPlus,{locale:zhCn}).mount('#app')
